import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import ReportTypeService from "../../services/report/ReportTypeService";
import { loadingReportTypeDropdown } from "../../store/slices/report/reportTypeSlice";

export const useReportType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { reportTypeDropdown } = useSelector(
    (state: RootState) => state.reportType
  );

  const fetchReportTypeDropdown = async () => {
    try {
      const response = await ReportTypeService.fetchDropdown();
      // console.log(response);
      dispatch(loadingReportTypeDropdown(response));
    } catch (error) {
      console.error("Error al cargar report types:", error);
    }
  };

  return {
    reportTypeDropdown,
    fetchReportTypeDropdown,
  };
};
